import { T } from "@classdojo/web";
import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib";
import * as React from "react";
import SmallCapsHeading from "./SmallCapsHeading";
import TeacherTips from "./TeacherTips";

const tips = [
  "Give your class some time to think.",
  "Ask the class to write down their answers… and no erasing!",
  "Encourage your students to be listeners by sharing with their neighbors.",
  "Get students moving! They can show their opinion by moving to different sides of the classroom.",
  "See if anyone changed their minds!",
];

interface State {
  showingTips: boolean;
}

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class WithTeacherTips extends React.Component<{ children: React.ReactNode }, State> {
  state: State = {
    showingTips: false,
  };

  render() {
    const { children } = this.props;
    return (
      <div>
        <div
          sx={{
            position: "fixed",
            bottom: 12,
            right: 12,
            borderRadius: "dt_radius_s",
            backgroundColor: "dt_background_tertiary",
            boxShadow: "dt_shadow_shadezies_small",
            padding: RAW_cssValue(12),
          }}
          onClick={() => {
            this.setState({ showingTips: true });
          }}
        >
          <SmallCapsHeading color="dt_content_light">
            <T str="dojo.toolkit:with_teacher_tips.tips" fallback="Tips" />
          </SmallCapsHeading>
        </div>
        <div
          sx={{
            // bottom padding so "Tips" button doesn't cover content
            paddingBottom: RAW_cssValue(36),
          }}
        >
          {children}
        </div>
        {this.state.showingTips && (
          <div
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "dt_background_primary",
              overflow: "auto",
            }}
          >
            <TeacherTips tips={tips} onClose={() => this.setState({ showingTips: false })} />
          </div>
        )}
      </div>
    );
  }
}
